export default __webpack_public_path__ + "static/media/hyperplanning.93481f77.png";